import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RolesEnum } from '@irembo-andela/irembogov3-common';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'irembogov-app-role-based-redirect',
  template: '<div>Redirecting...</div>',
})
export class RoleBasedRedirectComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    this.redirectBasedOnRole();
  }

  async redirectBasedOnRole() {
    const role = await this.authService.firstAllowedRole();

    // Check if user is admin
    if (role === RolesEnum.ROLE_IREMBOGOV_ADMIN) {
      this.router.navigate(['/services/templates']);
    } else {
      // For service managers and QA reviewers
      this.router.navigate(['/services']);
    }
  }
}
